import ApiService from '../_shared/api/apiService';
import Singleton from '../Singleton';
import StoreService from './StoreService';
import { DealerType } from '../_shared/types/user';

export default class UserService extends Singleton<UserService> {
  public getUsersList = async () => {
    const client = await ApiService();

    try {
      const response = await client.apis.user.getUserList({
        request: {}
      });

      return response?.body?.userSummaries;
    } catch (e) {
      return null;
    }
  };

  public isOnlyAccountant = user =>
    user?.isAccountant && !user?.isBuyerSeller && !user?.isCompanyAdmin;

  public isDealer = user => {
    const dealerTypes = [
      DealerType.dealerUser,
      DealerType.dealerLoaderUser,
      DealerType.universalUser
    ];

    return dealerTypes.indexOf(user?.type) !== -1;
  };

  public isDealerLoader = user => {
    return DealerType.dealerLoaderUser === user?.type;
  };

  public canViewReports = user =>
    !this.isDealerLoader(user) && !this.isOnlyAccountant(user);

  // Get user's dealership details
  public getDealerDetails = async ({ companyId }) => {
    const client = await ApiService();
    const storeService = StoreService.get();

    try {
      const dealerResponse = await client.apis.organization.getDealer({
        id: companyId
      });

      storeService.saveOrganizationDealer(dealerResponse?.body);

      return dealerResponse?.body;
    } catch (e) {
      throw new Error(e);
    }
  };

  public isSeller = (user, tradeDealerId) => {
    return this.isDealer(user) && user?.companyId === tradeDealerId;
  };
}
